<template>
  <el-dialog
    width="420px"
    :title="force ? '修改密码（已过期）' : '修改密码'"
    :visible="visible"
    :lock-scroll="false"
    :append-to-body="true"
    :close-on-click-modal="!force"
    :close-on-press-escape="!force"
    :show-close="!force"
    @update:visible="updateVisible"
    @closed="onClose">
    <el-alert
      v-if="force"
      title="密码已过期，请修改后再继续使用系统"
      type="warning"
      :closable="false"
      show-icon
      style="margin-bottom: 12px;" />
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="82px"
      @keyup.enter.native="save">
      <el-form-item label="旧密码:" prop="oldPassword">
        <el-input
          show-password
          v-model="form.oldPassword"
          placeholder="请输入" />
      </el-form-item>
      <el-form-item label="新密码:" prop="newPassword">
        <el-input
          show-password
          v-model="form.newPassword"
          :placeholder="passwordPlaceholder" />
      </el-form-item>
      <el-form-item label="确认密码:" prop="rePassword">
        <el-input
          show-password
          v-model="form.rePassword"
          placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button v-if="!force" @click="cancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UpdatePwd',
  props: {
    visible: Boolean,
    force: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters(['user']),
    passwordRule() {
      const info = (this.user && this.user.user) || {};
      const rule = info.password_rule || {};
      return {
        min: rule.min || 6,
        max: rule.max || 32,
        require_special: !!rule.require_special
      };
    },
    passwordPlaceholder() {
      let tip = `${this.passwordRule.min}-${this.passwordRule.max}位`;
      if (this.passwordRule.require_special) {
        tip += '，需含特殊字符';
      }
      return tip;
    },
    rules() {
      return {
        oldPassword: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请输入'));
              }
              const len = value.length;
              if (len < this.passwordRule.min) {
                return callback(new Error(`密码长度不能少于${this.passwordRule.min}位`));
              }
              if (len > this.passwordRule.max) {
                return callback(new Error(`密码长度不能超过${this.passwordRule.max}位`));
              }
              if (this.passwordRule.require_special && !/[\W_]/.test(value)) {
                return callback(new Error('密码必须包含特殊字符'));
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        rePassword: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请再次输入新密码'));
              }
              if (value !== this.form.newPassword) {
                return callback(new Error('两次输入密码不一致'));
              }
              callback();
            }
          }
        ]
      };
    }
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/index/updatePwd', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.$emit('done');
            this.cancel();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    onClose() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      };
      this.loading = false;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    cancel() {
      if (this.force) {
        return;
      }
      this.updateVisible(false);
    },
    updateVisible(value) {
      if (!value && this.force) {
        return;
      }
      this.$emit('update:visible', value);
    }
  }
};
</script>
